import { createTheme } from '@mui/material/styles';
import { legalInsightsTheme } from './LegalInsightsTheme';

const legalInsightsDarkTheme = createTheme({
  ...legalInsightsTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#FABD73',
    },
    secondary: {
      main: 'rgba(51, 51, 51, 0.87)',
    },
    text: {
      primary: '#FFFFFF',
    },
    background: {
      paper: 'rgba(0,0,0,0.85)',
    },
  },
  components: {
    ...legalInsightsTheme.components,
    MuiButton: {},
  },
});

// @NOTE: Check the Article.css for styles to be updated if you change anything here
if (legalInsightsDarkTheme.components?.MuiButton) {
  legalInsightsDarkTheme.components.MuiButton = {
    styleOverrides: {
      root: {
        color: '',
      },
    },
  };
}

export default legalInsightsDarkTheme;
